import { Browser, Device, Version } from "@kakaopay-common/user-agent";
import { isSelectedTabEnabledVersion, checkCurrentTabSelected } from "./checkSelectedTabEnabled.mjs";
function enableVisibilityChangeEvent() {
  if (typeof window === "undefined") {
    console.warn("visibilitychange can't be listened on node environment.");
    return;
  }
  if (Browser.isWaveWebview()) {
    console.warn("[payweb]visibilitychange can't be listened on the wave webview.");
    return;
  }
  const isTabViewSelectedEnabled = Browser.isTabWebview() && isSelectedTabEnabledVersion();
  if (isPauseResumeEnabled()) {
    window.KakaoPay.triggerPause = function() {
      if (isTabViewSelectedEnabled) {
        checkCurrentTabSelected().then(triggerPause).catch(() => {
          console.warn("triggerPause is not trigger");
        });
      } else {
        triggerPause();
      }
    };
    window.KakaoPay.triggerResume = function() {
      if (isTabViewSelectedEnabled) {
        checkCurrentTabSelected().then(triggerResume).catch(() => {
          console.warn("triggerResume is not trigger");
        });
      } else {
        triggerResume();
      }
    };
    window.KakaoPay.triggerWillResume = function() {
      if (isTabViewSelectedEnabled) {
        checkCurrentTabSelected().then(triggerWillResume).catch(() => {
          console.warn("triggerWillResume is not trigger");
        });
      } else {
        triggerWillResume();
      }
    };
    window.KakaoPay.triggerWillPause = function() {
      if (isTabViewSelectedEnabled) {
        checkCurrentTabSelected().then(triggerWillPause).catch(() => {
          console.warn("triggerWillPause is not trigger");
        });
      } else {
        triggerWillPause();
      }
    };
  } else {
    document.addEventListener("visibilitychange", () => {
      document.dispatchEvent(
        new Event(document.visibilityState === "visible" ? "resume" : "pause")
      );
    });
  }
}
function isPauseResumeEnabled() {
  const currentVersion = Browser.getAppVersion();
  return Device.isAndroid() || Device.isIos() && Browser.isKakaoTalkApp() && Version.isGreaterThanOrEqualTo(currentVersion, "9.6.5") || Browser.isKakaoPayApp() && Version.isGreaterThanOrEqualTo(currentVersion, "2.4.0");
}
function triggerPause() {
  console.log("[new visibilitychange.ts] triggerPause");
  document.dispatchEvent(new Event("pause"));
}
function triggerResume() {
  console.log("[new visibilitychange.ts] triggerResume");
  document.dispatchEvent(new Event("resume"));
}
function triggerWillPause() {
  console.log("[new visibilitychange.ts] triggerWillPause");
  document.dispatchEvent(new Event("will_pause"));
}
function triggerWillResume() {
  console.log("[new visibilitychange.ts] triggerWillResume");
  document.dispatchEvent(new Event("will_resume"));
}
export {
  enableVisibilityChangeEvent
};
